module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td class="center" style="display: none"><input type="checkbox" class="check-ff-form"></td>\n<td class="center">\n    ';
 if (signedDocumentId) { 
__p+='\n    <a href="/api/document/view/'+
((__t=( signedDocumentId ))==null?'':__t)+
'" target="_blank" class="preview-doc"><span class="clickable glyphicon glyphicon-eye-open"/></a>\n    ';
 } 
__p+='\n</td>\n<td class="center">\n    ';
 if (signedDocumentId) { 
__p+='\n    <a href="/api/document/download/'+
((__t=( signedDocumentId ))==null?'':__t)+
'" class="preview-doc"><span class="clickable glyphicon glyphicon-floppy-disk"/></a>\n    ';
 } 
__p+='\n</td>\n<td class="center">'+
((__t=( id ))==null?'':__t)+
'</td>\n<td>'+
((__t=( faceToFaceDate ))==null?'':__t)+
'</td>\n<td>'+
((__t=( data.hospital.name ))==null?'':__t)+
'</td>\n<td>'+
((__t=( patient ))==null?'':__t)+
'</td>\n<td>'+
((__t=( reviewer ))==null?'':__t)+
'</td>\n<td>'+
((__t=( requestingOrg ))==null?'':__t)+
'</td>\n<td>'+
((__t=( creator ))==null?'':__t)+
'</td>\n<td>'+
((__t=( isSigned ))==null?'':__t)+
'</td>\n<td>'+
((__t=( signedTime ))==null?'':__t)+
'</td>\n';
 if (currentUserDo) { 
__p+='\n<td><span class=\'glyphicon glyphicon-remove clickable remove-face-to-face-form\' title=\'Remove\'/></td>\n';
 } 
__p+='';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/med-forms/face-to-face-item.html
// module id = 525
// module chunks = 0